import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;

  if (!dsn) {
    // eslint-disable-next-line no-console
    console.warn('[Sentry] REACT_APP_SENTRY_DSN belum diatur. Sentry tidak aktif.');
    return;
  }

  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [new BrowserTracing()],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_VERSION,
    // Adjust this value in production to control performance monitoring sample rate
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE) || 1.0,
  });
}

export default Sentry;
